import { useSetRecoilState } from 'recoil'
import { useMutation } from '@apollo/client';
import { DASHBOARD_CHANGE_BOOKING_ADDONS} from 'graphql/service';

import { reloadTrips } from  'states/CommonStates/atoms';

import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';

/**
 * A custom hook to change booking adons
 */


export const useChangeAddons = () => {

  const { showGlobalError, showGlobalMessage } = useGlobalAlerts();

  const debug = false;
  
  

  const setReloadTrips = useSetRecoilState(reloadTrips);



  const [changeAddons] = useMutation(DASHBOARD_CHANGE_BOOKING_ADDONS, {
    onCompleted: (data) => {

      if (debug) {
          console.log ('changeAddons data =', data);
      }

      showGlobalMessage("Your booking has been successfully modified.");
      setReloadTrips(true);

    },
    onError: (error) => {
      const content = error.message;
      
      showGlobalError(content);


      if (debug) {
        console.log("changeAddons error =", error);
      }
    },
  });

  type ChangeAddonItem = {
    bookingId: string;
    id: string;
    quantity: number;
    numberOfNights?: number;
  };

  const handleChangeAddons = (addonsArray: ChangeAddonItem[]) => {
    changeAddons({
      variables: {
        input: {
          addOns: addonsArray
        }
      },
    });
  };

  return {
    handleChangeAddons
  }
}

